module.exports = __webpack_public_path__ + "img/img_biaoti@2x.e4603133.png";